import { render, staticRenderFns } from "./DiagnosticoScreenDetalhado.vue?vue&type=template&id=0c473e77&scoped=true&"
import script from "./DiagnosticoScreenDetalhado.vue?vue&type=script&lang=js&"
export * from "./DiagnosticoScreenDetalhado.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticoScreenDetalhado.vue?vue&type=style&index=0&id=0c473e77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c473e77",
  null
  
)

export default component.exports